export default "__VITE_ASSET__Cw84sZIY__"